import React from 'react';
import './App.css';
import banner from './assets/banner.png';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={banner} alt="AI Made Me Do It banner" className="App-banner" />
        <h2 className="App-tagline">Learning AI one glorious mistake at a time</h2>
      </header>
      <main>
        <section className="App-about">
          <h3>About</h3>
          <p>
            Welcome to AImademedoit! Join Scholty as we explore the world of AI, learning from every glorious mistake along the way. Whether you're a beginner or an enthusiast, there's something here for everyone.
          </p>
        </section>
        <section className="App-social">
          <h3>Find us online</h3>
          <ul>
            <li><a href="#">YouTube</a> (coming soon)</li>
            <li><a href="#">Blog</a> (coming soon)</li>
          </ul>
        </section>
      </main>
    </div>
  );
}

export default App; 